import FormatOption from './FormatOption';
import compose from 'recompose/compose';
import withProps from 'recompose/withProps';
import withHandlers from 'recompose/withHandlers';
import get from 'lodash/get';
import {
  trackFormatDrawerSaveTab,
  trackFormatDrawerChanged,
} from 'src/client/js/analytics/category/product';

const enhance = compose(
  withHandlers({
    onChange: props => () => {
      trackFormatDrawerSaveTab();
      const value = props.prismicFormat.formatId;
      if (value) {
        trackFormatDrawerChanged();
      }
      props.onFormikSubmit({ format_identifier: value });
    },
  }),
  withProps(props => {
    let variant;
    if (props.variant) {
      const [formatted, currency] = get(props.variant, 'price.formatted', '').split(' ');
      variant = {
        ...props.variant,
        price: {
          formatted,
          currency
        }
      };
    }
    return {
      isSelected: props.formatIdentifier === props.prismicFormat.formatId,
      variant,
    };
  }),
);

export default enhance(FormatOption);



// WEBPACK FOOTER //
// ./src/client/js/view/components/CreationForm/Formats/FormatOption/index.js